import { lazyload } from './lazyload';
import { forEach } from '@mindkomm/utils';
export function initLazyImages() {
  var lazySelector = '.lazy';
  var lazyProgressiveSelector = '.lazy-progressive';
  /**
   * Lazy load elements.
   *
   * Items will only be loaded when they are about to enter the viewport.
   */

  var observer = lazyload(lazySelector, {
    loaded: function loaded(el) {
      /**
       * Picturefill needs to be invoked after images have srcset attributes.
       *
       * @link https://github.com/scottjehl/picturefill/issues/633#issuecomment-179282847
       */
      if (typeof window.picturefill === 'function') {
        picturefill();
      }

      el.onload = function () {
        el.removeAttribute('data-src');
        el.removeAttribute('data-srcset');
        el.removeAttribute('data-sizes');
      };
    }
  });
  observer.observe();
  /**
   * Load items progressively.
   *
   * This will load all items progressively, even when they are not in the viewport yet.
   * This is helpful for slider images that should load in the background, for example in a slider.
   */

  forEach(document.querySelectorAll(lazyProgressiveSelector), function (el) {
    observer.triggerLoad(el);
  });
}